// extracted by mini-css-extract-plugin
export default {"Card":"APfliyb_w2MgzBC_14vu"};